import React, { useEffect, useRef } from 'react'
import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import LogoHeader from '../LogoHeader'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'
import { exitApp } from '../../../../shared/helpers'
import tts from '../../lib/TTS'

import type { ExitAppModalProps } from './types'
import { useSidePanel } from '../SidePanel/SidePanelProvider'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'

const ExitAppModalTS = ({ withoutLogoHeader, onCancel }: ExitAppModalProps) => {
  const { focusKey, ref, focusSelf } = useFocusable()
  useKeyDown(KeyTypeEnum.Back, onCancel, { stopPropagation: true })
  const { setKeepSidePanelOpened } = useSidePanel()
  const previousKeepOpenRef = useRef(false)

  useEffect(() => {
    setKeepSidePanelOpened((prev) => {
      previousKeepOpenRef.current = prev
      return true
    })
    return () => {
      setKeepSidePanelOpened(previousKeepOpenRef.current)
    }
  }, [setKeepSidePanelOpened])

  useEffect(() => {
    tts.pushTextToRead('Are you sure you want to exit PBS Video?')
    focusSelf()
    return () => tts.stopRead()
  }, [])

  const buttonSpeaker = (text: string) => {
    tts.stopRead()
    tts.addTextToRead(text)
  }

  return (
    <div className="exit-app-modal-ts">
      {!withoutLogoHeader && (
        <LogoHeader className="exit-app-modal-ts__logo-header" />
      )}
      <h1 className="exit-app-modal-ts__title">
        Are you sure you want to exit PBS Video?
      </h1>
      <FocusContext.Provider value={focusKey}>
        <div ref={ref} className="exit-app-modal-ts__buttons-container">
          <FocusableButtonTS
            onEnterPress={onCancel}
            onArrowPress={(direction) => direction === 'right'}
            onFocus={() => buttonSpeaker('Focused on cancel')}
            className="exit-app-modal-ts__button"
          >
            CANCEL
          </FocusableButtonTS>
          <FocusableButtonTS
            onEnterPress={exitApp}
            onArrowPress={(direction) => direction === 'left'}
            onFocus={() => buttonSpeaker('Focused on exit')}
            className="exit-app-modal-ts__button"
          >
            EXIT
          </FocusableButtonTS>
        </div>
      </FocusContext.Provider>
    </div>
  )
}

export default ExitAppModalTS
